// @ts-ignore
import moment, { Moment } from 'moment';

export const getCustomSchedule = (settings: any[]) => {
	const weekMap = {
		'1': 'monday',
		'2': 'tuesday',
		'3': 'wednesday',
		'4': 'thursday',
		'5': 'friday',
		'6': 'saturday',
		'7': 'sunday',
	};
	const days = [];
	for (const item of settings) {
		const dayExist = days.findIndex(
			m => m.value === weekMap[item.customDayOfWeek?.value],
		);
		if (dayExist < 0) {
			days.push({
				type: 'day',
				value: weekMap[item.customDayOfWeek?.value],
				children: [
					{
						type: 'time',
						value: moment(item.customTime).format('HH:mm'),
					},
				],
			});
		} else {
			days[dayExist].children.push({
				type: 'time',
				value: moment(item.customTime).format('HH:mm'),
			});
		}
	}
	return {
		periods: [
			{
				type: 'weekly',
				children: days,
			},
		],
	};
};
